import { Pipe, PipeTransform } from '@angular/core';
import i18next from 'i18next';

@Pipe({
  name: 'translatepipe',
  standalone: true,
  pure: false
})
export class TranslatePipe implements PipeTransform {
  transform(key: string, args?: any): string {
    return String(i18next.t(key, args));
  }
}
